export default {"src":"/_next/static/media/mail-icon.21411c1b.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};